import React, { useState, useEffect } from 'react';
import { List, Tooltip } from 'antd';
import classnames from 'classnames';
import { highlightName, highlightText } from '@web-mail-write/util';
import { Checkbox } from '../Contact/contact';
import styles from './contactItem.module.scss';
const ContactItem = props => {
    const { item, search, chooseMember, chosen, disabled = false } = props;
    const { contactName, hitQuery, position, accountName } = item;
    const email = accountName || '';
    const [checked, setChecked] = useState(false);
    useEffect(() => {
        setChecked(chosen);
    }, [chosen]);
    const htmlName = highlightName(contactName, hitQuery, search, styles.hitText);
    const highlightedEmail = highlightText(email, search, styles.hitText);
    const htmlEmail = highlightedEmail ? `(${highlightedEmail})` : '';
    const pos = position ? position.map(pos => `\u00b7 ${pos.join('\u2014')}`) : [];
    const titleNode = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.mainTitle }, contactName),
        !!email && React.createElement("div", { className: styles.subTitle }, email),
        pos.map(item => (React.createElement("div", { key: item, className: styles.subTitle }, item)))));
    const onSelect = () => {
        if (!disabled && chooseMember) {
            setChecked(chooseMember(item));
        }
    };
    const title = (React.createElement(Tooltip, { title: titleNode, destroyTooltipOnHide: { keepParent: false }, placement: "bottomLeft", overlayClassName: "member-contact-tooltip", mouseLeaveDelay: 0 },
        React.createElement("div", { className: styles.itemTitle, onClick: onSelect },
            React.createElement(Checkbox, { checked: checked, disabled: disabled, style: { position: 'absolute', left: '16px', top: '6px' } }),
            React.createElement("span", { className: styles.nameTitleText, dangerouslySetInnerHTML: {
                    __html: htmlName,
                } }),
            htmlEmail && (React.createElement("span", { className: styles.emailTitleText, dangerouslySetInnerHTML: {
                    __html: htmlEmail,
                } })))));
    return (React.createElement(List.Item, { className: classnames([styles.item], { [styles.itemSelected]: checked }) },
        React.createElement(List.Item.Meta, { title: title })));
};
export default ContactItem;
